export default "__VITE_ASSET__QqbarIpF__"